<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<p>I thank my wife, Donna, sister Shelley and relatives for offering up constructive criticism while reading my initial manuscript. Additionally, I thank the editing and production team at Austin Macauley Publishers for work on the refinement of the script to polish it into this book.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?0787c995